<template>
  <default :vacancy-id="vacancyId" />
</template>

<script>
import { mapState } from 'vuex';
import basic from './default.vue';

export default {
  name: 'ApplicationIndex',

  components: {
    default: basic
  },

  beforeRouteLeave(to, from, next) {
    let confirmDelete = true;

    if (this.changes) {
      confirmDelete = confirm(this.$tr('vacancy.confirm.leave'));
      if (!confirmDelete) {
        next(false);
        return false;
      }
    }

    next();
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$store.getters['vacancy_new/modules/allow_application'] === false) {
        next({ name: 'vacancy_application' });
      }
    });
  },

  props: {
    vacancyId: {
      type: [String, Number],
      default: ''
    }
  },

  computed: {
    ...mapState('vacancy/application', ['changes'])
  }
};
</script>
